import React, { useEffect, useState } from "react";
import Sunburst from "./Sunburst";
import { formatSunburstData } from "./FormatSunburstData";
import useUnifiedAPI from "../../../../Hooks/useApi";
import { fetchSunburtData } from "./sunburstUtils";
import LoadingSpinner from "../../../Shared/LoadingSpinner";
import { NoDataBox } from "../NoDataFoundMessage";


const SunburstContainer = ({ width, height, surveyId, locationId, type }) => {

  const [sunburstData, setSunburstData] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  
  const { request, loading } = useUnifiedAPI({ isPublic: true });

  useEffect(() => {
 
    setSunburstData(null);
    setErrorMessage(null);

  
    if (!surveyId || !locationId) {
      return;
    }

    const fetchData = async () => {
      try {
     
        const response = await fetchSunburtData(request, {
          locationId,
          surveyId,
          type,
        });

        if (!response) {
          throw new Error("Received empty response from server.");
        }

  
        let formattedData;
        try {
           formattedData = formatSunburstData(response, type);
        } catch (formatError) {
          console.error("Data Formatting Error:", formatError);
          throw new Error("Data structure is invalid and cannot be visualized.");
        }

       
        if (formattedData && Array.isArray(formattedData.children)) {
          setSunburstData(formattedData);
        } else {
      
          setSunburstData(null); 
        }

      } catch (err) {
        console.error("Sunburst Container Error:", err);
        setErrorMessage(err.message || "Something went wrong loading the chart.");
      }
    };

    fetchData();
  }, [type, surveyId, locationId, request]); 


  if (loading) {
    return <LoadingSpinner message="Loading Chart..." />;
  }


  if (errorMessage) {
    return (
        <div className="p-4 border border-red-200 bg-red-50 rounded h-full flex flex-col justify-center items-center">
        <h2 className="text-16 text-center text-lg text-red-500 font-semibold">
          Unable to load chart
          <br />
          <p className="text-sm text-gray-600">{errorMessage}</p>
        </h2>

      </div>
    );
  }

  return (
    <>
      {sunburstData && sunburstData?.children?.length > 0 ? (
        <div className="flex justify-center">
          
          <Sunburst
            width={width}
            height={height}
            sunburst_data={sunburstData}
          />
        </div>
      ) : (
       <NoDataBox/>
     
      )}
    </>
  );
};

export default SunburstContainer;